import Vue from "vue";

const success = (context, response) => {
  toastr.success("Mis à jour avec succès");
};

const failed = (context, error) => {};

export default (context, invoice, info, logo) => {
  const fd = new FormData();
  fd.append("image", logo);
  fd.append("invoice", JSON.stringify(invoice));
  fd.append("info", JSON.stringify(info));

  return Vue.$http
    .post(`superconciergerie/settings`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      success(context, response.data);
    })
    .catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/superconciergerie/update-settings.js